import React from 'react';
import { render } from 'react-dom';
import { createBrowserHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';
import { routerMiddleware } from 'react-router-redux';
import { applyMiddleware, createStore, compose } from 'redux';
import { ThemeProvider } from '@material-ui/core/styles';
import PapayaTheme, { palette } from './papaya-theme';

import 'normalize.css';
import './index.css';
import App from './app';
import Saga from './sagas/sagas';
import reducer from './reducers/reducer';
import registerServiceWorker from './registerServiceWorker';

const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const middleware = applyMiddleware(routerMiddleware(history), sagaMiddleware);
const composed = compose(
  middleware,
  ...(window.__REDUX_DEVTOOLS_EXTENSION__
    ? [window.__REDUX_DEVTOOLS_EXTENSION__()]
    : [])
);
const store = createStore(reducer, composed);
sagaMiddleware.run(Saga);

for (let entry in palette) {
  if (palette.hasOwnProperty(entry)) {
    document
      .getElementsByTagName('html')[0]
      .style.setProperty(`--${entry}`, palette[entry]);
  }
}

class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.log(error, info);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }
    return this.props.children;
  }
}

render(
  <Provider store={store}>
    <ThemeProvider theme={PapayaTheme}>
      <ErrorBoundary>
        <App history={history} />
      </ErrorBoundary>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js